import { createContext } from 'react';

export const DEFAULT_VALUE = {
    search: "",
    setSearch: () => {}
}

export const searchContext = createContext(DEFAULT_VALUE);